<template>
    <v-flex v-if="content" class="database-content">
        <div v-if="content.title" class="headline mb-4">{{ content.title }}</div>
        <v-flex class="light-font" v-html="content.text" />
    </v-flex>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
    },
  },

};
</script>
<style lang="less" scoped>
.database-content {
  margin-bottom: 40px
}
</style>

